import { render, staticRenderFns } from "./u-chip-outlined-label.vue?vue&type=template&id=01d91b31&scoped=true&"
import script from "./u-chip-outlined-label.vue?vue&type=script&lang=js&"
export * from "./u-chip-outlined-label.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d91b31",
  null
  
)

export default component.exports